let INPUT_EEROR = require("./../common").INPUT_EEROR;
let Common = require("./../common").Common;
let pushLength = require("./../common").pushLength;
let parseAppointLen = require("./../common").parseAppointLen;
let appointLen = require("./../common").appointLen;
let reverse = require("./../common").reverse;
let fullHex = require("./../common").fullHex;
// 数据回收解析工具类

var Parse = {};

// 4.17.1 秤的硬件信息
Parse.checkDeviceHardware = function (data, encoding) {
    var param = {
        data: data,
        val: ''
    };
    var ret = {};
    param = Common.bit6(param);
    ret.mac = param.val;
    param = Common.pbit1(param);
    ret.utc4 = param.val;
    param = Common.pbit1(param);
    ret.line = hex2Ascii(param.val.toString(16));
    param = Common.pbit4(param);
    ret.wire_ip = ret.line.toUpperCase() == 'C' ? Common.sortIP(param.val.toString(16)) : param.val;
    param = Common.pbit4(param);
    ret.wireless_ip = ret.line.toUpperCase() == 'W' ? Common.sortIP(param.val.toString(16)) : param.val;
    param = Common.pbit4(param);
    ret.data_storage = param.val;
    param = Common.pbit4(param);
    ret.font_storage = param.val;
    param = Common.pbit1Ascii(param);
    ret.charset = param.val;
    ret.encoding = 'C' != ret.charset ? "UTF-8" : "GBK";
    param = Common.pbit1Hex(param);
    ret.default_font_number = param.val;
    param = Common.pTxt(param, ret.encoding);
    ret.version = param.val;
    return ret;
};

// 4.17.2 秤的识别信息
Parse.checkDeviceName = function (data, encoding) {
    var param = {
        data: data,
        val: ''
    };
    var ret = {};
    param = Common.pTxt(param, encoding);
    ret.store_name = param.val;
    param = Common.pTxt(param, encoding);
    ret.device_name = param.val;
    param = Common.pTxt(param, encoding);
    ret.device_num = param.val;
    return ret;
};

// 4.17.3 秤的时间信息
Parse.checkDeviceTime = function (data) {
    var param = {
        data: data,
        val: ''
    };
    var ret = {};
    param = Common.pbit4(param);
    ret.time = new Date((946656000 + param.val) * 1000);
    return ret;
};

Parse.Log = function (dId, data, encoding, base64) {
    var param = {
        data: data,
        val: '',
        float: ''
    };

    var log = {};
    log.dId = dId;

    //todo 后台处理压缩+Base64加密 前端需要Base64解密+解压
    if (base64) {
        var base = new Base64()
        var bytes = base.decodeToBytes(data);
        var gunzip = new Zlib.Gunzip(bytes);
        var plain = gunzip.decompress();
        var asciistring = new TextDecoder("utf-8").decode(plain);
        param.data = asciistring
    }

    param = Common.pTime(param);
    log.date = param.val;

    param = Common.pbit4(param);
    log.sid = param.val;

    param = Common.pSPF(param);
    log.money = param.val;

    param = Common.pbit1(param);
    log.logType = param.val;

    param = Common.pbit1(param);
    log.number = param.val;

    param = pFloat(param);
    var float = param.float;

    if (float[0] && float[0] == '1') {
        param = Common.pbit4(param);
        log.shopManId = param.val;
    }

    if (float[1] && float[1] == '1') {
        param = Common.pSPF(param);
        log.amountOfDiscount = param.val;
    }

    if (float[2] && float[2] == '1') {
        param = Common.pSPF(param);
        log.cesse = param.val;
    }

    if (float[3] && float[3] == '1') {
        param = Common.pSPF(param);
        log.cost = param.val;
    }

    if (float[4] && float[4] == '1') {
        param = Common.pSPF(param);
        log.cardPayment = param.val;
    }

    if (float[5] && float[5] == '1') {
        param = Common.pSPF(param);
        log.otherPay1 = param.val;
    }

    if (float[6] && float[6] == '1') {
        param = Common.pSPF(param);
        log.otherPay2 = param.val;
    }

    if (float[16] && float[16] == '1') {
        param = Common.pSPF(param);
        log.otherPay3 = param.val;
    }

    if (float[17] && float[17] == '1') {
        param = Common.pSPF(param);
        log.serviceCharge = param.val;
    }

    if (float[18] && float[18] == '1') {
        param = Common.pbit4(param);
        log.coFid = param.val;
    }

    if (float[19] && float[19] == '1') {
        param = Common.pSPF(param);
        log.aliPay = param.val;
    }

    if (float[20] && float[20] == '1') {
        param = Common.pSPF(param);
        log.weixinPay = param.val;
    }

    if (float[21] && float[21] == '1') {
        param = Common.pSPF(param);
        log.specialPay2 = param.val;
    }

    if (float[22] && float[22] == '1') {
        param = Common.pSPF(param);
        log.specialPay3 = param.val;
    }

    if (float[23] && float[23] == '1') {
        param = Common.pSPF(param);
        log.specialPay4 = param.val;
    }

    if (float[24] && float[24] == '1') {
        param = Common.pSPF(param);
        log.specialPay5 = param.val;
    }

    if (float[25] && float[25] == '1') {
        param = Common.pSPF(param);
        log.specialPay6 = param.val;
    }

    if (float[26] && float[26] == '1') {
        param = Common.pSPF(param);
        log.specialPay7 = param.val;
    }

    if (float[27] && float[27] == '1') {
        param = Common.pbit4(param);
        log.errCode = param.val;
    }

    if (float[28] && float[28] == '1') {
        param = Common.pTxt(param);
        log.errMsg1 = param.val;
    }

    if (float[29] && float[29] == '1') {
        param = Common.pTxt(param);
        log.errMsg2 = param.val;
    }

    if (float[30] && float[30] == '1') {
        param = Common.pTxt(param);
        log.errMsg3 = param.val;
    }

    if (float[31] && float[31] == '1') {
        param = Common.pTxt(param);
        log.errMsg4 = param.val;
    }

    if (float[32] && float[32] == '1') {
        param = Common.pSPF(param);
        log.jkyPay = param.val;
    }

    if (float[33] && float[33] == '1') {
        param = Common.pSPF(param);
        log.jkyGivePay = param.val;
    }

    if (float[34] && float[34] == '1') {
        param = Common.pSPF(param);
        log.recharge = param.val;
    }

    if (float[35] && float[35] == '1') {
        param = Common.pSPF(param);
        log.giveRecharge = param.val;
    }

    var goods = [];

    for (var i = 0; i < log.number; i++) {
        var good = {};
        param = Common.pbit1(param);
        good.unit = param.val;

        param = Common.pbit4(param);
        good.pluNo = param.val;

        param = Common.pSPF(param);
        good.weigth = param.val;

        param = Common.pSPF(param);
        good.univalent = param.val;

        param = Common.pSPF(param);
        good.singleMeter = param.val;

        param = Common.pTxt(param, encoding);
        good.tradeName = param.val;

        param = pFloat(param);
        float = param.float;

        if (float[0] && float[0] == '1') {
            param = Common.pbit2(param);
            good.groupNo = param.val;

            param = Common.pbit1(param);
            good.deptNo = param.val;
        }

        if (float[1] && float[1] == '1') {
            param = Common.pSPF(param);
            good.costTrade = param.val;
        }

        if (float[2] && float[2] == '1') {
            param = Common.pSPF(param);
            good.amount = param.val;
        }

        if (float[3] && float[3] == '1') {
            param = Common.pTxt(param);
            log.text1 = param.val;
        }

        if (float[4] && float[4] == '1') {
            param = Common.pTxt(param);
            log.text2 = param.val;
        }

        if (float[5] && float[5] == '1') {
            param = Common.pTxt(param);
            log.text3 = param.val;
        }

        if (float[6] && float[6] == '1') {
            param = Common.pTxt(param);
            log.text4 = param.val;
        }

        if (float[16] && float[16] == '1') {
            param = Common.pbit1(param);
            good.logTypeTrade = param.val;
        }
        goods.push(good);
    }
    log.goods = goods;
    return log;
};

Parse.Department = function (dId, data, encoding) {
    var param = {
        data: data,
        val: ''
    };
    var department = {};
    department.dId = dId;
    department.name = Common.pTxt(param, encoding).val;
    return department;
};

Parse.Group = function (dId, data, encoding) {
    var param = {
        data: data,
        val: '',
        float: ''
    };
    var group = {};
    group.dId = dId;

    param = Common.pTxt(param, encoding);
    group.name = param.val;

    param = Common.pbit1(param);
    group.department = param.val;

    param = pFloat(param);
    var float = param.float;

    if (float[0] && float[0] == '1') {
        param = Common.pbit2(param);
        group.putType1 = param.val;
    }

    if (float[1] && float[1] == '1') {
        param = Common.pbit2(param);
        group.barType1 = param.val;
    }

    if (float[2] && float[2] == '1') {
        param = Common.pbit2(param);
        group.barSgin1 = param.val;
    }

    if (float[3] && float[3] == '1') {
        param = Common.pbit2(param);
        group.putType2 = param.val;
    }

    if (float[4] && float[4] == '1') {
        param = Common.pbit2(param);
        group.barType2 = param.val;
    }

    if (float[5] && float[5] == '1') {
        param = Common.pbit2(param);
        group.barSgin2 = param.val;
    }

    return group;
};

Parse.PLU = function (dId, data, encoding) {
    var param = {
        data: data,
        val: '',
        float: ''
    };

    var plu = {};
    plu.dId = dId;

    param = Common.pTxt(param, encoding);
    plu.name = param.val;

    param = Common.pbit1(param);
    plu.weigth = param.val;

    param = Common.pSPF(param);
    plu.price = param.val;

    param = pFloat(param);
    var float = param.float;

    if (float[0] && float[0] == '1') {
        param = Common.pbit4(param, true);
        plu.number = param.val;
    }

    if (float[1] && float[1] == '1') {
        param = Common.pTxt(param, encoding);
        plu.indexBar = param.val;
    }

    if (float[2] && float[2] == '1') {
        param = Common.pbit1(param);
        plu.useDatePut = param.val;

        param = Common.pbit2(param, encoding);
        plu.useDateData = param.val;
    }

    if (float[3] && float[3] == '1') {
        param = Common.pSPF(param);
        plu.costTrade = param.val;
    }

    if (float[4] && float[4] == '1') {
        param = Common.pSPF(param);
        plu.trae = param.val;
    }

    if (float[5] && float[5] == '1') {
        param = Common.pbit2(param);
        plu.group = param.val;
    }

    if (float[6] && float[6] == '1') {
        param = Common.pbit2(param);
        plu.putType1 = param.val;
    }

    if (float[16] && float[16] == '1') {
        param = Common.pbit2(param);
        plu.barNo1 = param.val;
    }

    if (float[17] && float[17] == '1') {
        param = Common.pbit2(param);
        plu.barType1 = param.val;
    }

    if (float[18] && float[18] == '1') {
        param = Common.pbit2(param);
        plu.putType2 = param.val;
    }

    if (float[19] && float[19] == '1') {
        param = Common.pbit2(param);
        plu.barNo2 = param.val;
    }

    if (float[20] && float[20] == '1') {
        param = Common.pbit2(param);
        plu.barType2 = param.val;
    }

    if (float[21] && float[21] == '1') {
        param = Common.pTxt(param, encoding);
        plu.text1 = param.val;
    }

    if (float[22] && float[22] == '1') {
        param = Common.pTxt(param, encoding);
        plu.text2 = param.val;
    }

    if (float[23] && float[23] == '1') {
        param = Common.pTxt(param, encoding);
        plu.text3 = param.val;
    }

    if (float[24] && float[24] == '1') {
        param = Common.pTxt(param, encoding);
        plu.text4 = param.val;
    }

    if (float[25] && float[25] == '1') {
        param = Common.pTxt(param, encoding);
        plu.text5 = param.val;
    }

    if (float[26] && float[26] == '1') {
        param = Common.pTxt(param, encoding);
        plu.text6 = param.val;
    }

    if (float[27] && float[27] == '1') {
        param = Common.pTxt(param, encoding);
        plu.text7 = param.val;
    }

    if (float[28] && float[28] == '1') {
        param = Common.pbit1(param);
        plu.taxType = param.val;

        param = Common.pbit4(param);
        plu.taxExtreme = param.val;
    }

    if (float[29] && float[29] == '1') {
        param = Common.pbit2(param);
        plu.picNo = param.val;
    }

    if (float[30] && float[30] == '1') {
        param = Common.pbit1(param);
        plu.saleDatePut = param.val;
        param = Common.pbit2(param);
        plu.saleDateData = param.val;
    }

    if (float[31] && float[31] == '1') {
        param = Common.pbit1(param);
        plu.saleTimePut = param.val;
        param = Common.pbit2(param);
        plu.saleTimeData = param.val;
    }

    if (float[32] && float[32] == '1') {
        param = Common.pbit1(param);
        plu.packDatePut = param.val;
        param = Common.pbit2(param);
        plu.packDateData = param.val;
    }

    if (float[33] && float[33] == '1') {
        param = Common.pbit1(param);
        plu.packTimePut = param.val;
        param = Common.pbit2(param);
        plu.packTimeData = param.val;
    }

    if (float[34] && float[34] == '1') {
        param = Common.pbit1(param);
        plu.manualDiscountLower = param.val;
        param = Common.pSPF(param);
        plu.manualDiscountLowerValue = param.val;
    }

    if (float[35] && float[35] == '1') {
        param = Common.pbit1(param);
        plu.manualDiscountUpper = param.val;
        param = Common.pSPF(param);
        plu.manualDiscountUpperValue = param.val;
    }

    if (float[36] && float[36] == '1') {
        param = Common.pbit1(param);
        plu.customDiscount0Type = param.val;
        param = Common.pbit1(param);
        plu.customDiscount0UseDate = param.val;
        param = Common.pSPF(param);
        plu.customDiscount0Lower = param.val;
        param = Common.pSPF(param);
        plu.customDiscount0Upper = param.val;
        param = Common.pSPF(param);
        plu.customDiscount0Value = param.val;
    }

    if (float[37] && float[37] == '1') {
        param = Common.pbit1(param);
        plu.customDiscount1Type = param.val;
        param = Common.pbit1(param);
        plu.customDiscount1UseDate = param.val;
        param = Common.pSPF(param);
        plu.customDiscount1Lower = param.val;
        param = Common.pSPF(param);
        plu.customDiscount1Upper = param.val;
        param = Common.pSPF(param);
        plu.customDiscount1Value = param.val;
    }

    if (float[38] && float[38] == '1') {
        param = Common.pbit1(param);
        plu.customDiscount2Type = param.val;
        param = Common.pbit1(param);
        plu.customDiscount2UseDate = param.val;
        param = Common.pSPF(param);
        plu.customDiscount2Lower = param.val;
        param = Common.pSPF(param);
        plu.customDiscount2Upper = param.val;
        param = Common.pSPF(param);
        plu.customDiscount2Value = param.val;
    }

    if (float[39] && float[39] == '1') {
        param = Common.pbit1(param);
        plu.customDiscount3Type = param.val;
        param = Common.pbit1(param);
        plu.customDiscount3UseDate = param.val;
        param = Common.pSPF(param);
        plu.customDiscount3Lower = param.val;
        param = Common.pSPF(param);
        plu.customDiscount3Upper = param.val;
        param = Common.pSPF(param);
        plu.customDiscount3Value = param.val;
    }

    if (float[40] && float[40] == '1') {
        param = Common.pbit4(param);
        plu.sspValue1 = param.val;
    }

    if (float[41] && float[41] == '1') {
        param = Common.pbit4(param);
        plu.sspValue2 = param.val;
    }

    if (float[42] && float[42] == '1') {
        param = Common.pbit4(param);
        plu.sspValue3 = param.val;
    }

    if (float[43] && float[43] == '1') {
        param = Common.pbit4(param);
        plu.sspValue4 = param.val;
    }

    if (float[44] && float[44] == '1') {
        param = Common.pbit1(param);
        plu.pluType = param.val;
    }

    if (float[45] && float[45] == '1') {
        param = Common.pbit2(param);
        plu.pluSgin = param.val;
    }

    if (float[46] && float[46] == '1') {
        param = Common.pbit4(param);
        plu.pluSginValue = param.val;
    }

    if (float[47] && float[47] == '1') {
        param = Common.pTxt(param, encoding);
        plu.pingyinSearch = param.val;
    }

    return plu;
};

Parse.BarCode = function (dId, data, encoding) {
    var param = {
        data: data,
        val: '',
        float: ''
    };

    var barCode = {};
    barCode.dId = dId;

    param = Common.pTxt(param, encoding);
    barCode.name = param.val;

    param = Common.pbit1(param);
    barCode.type = param.val;

    param = Common.pTxt(param, encoding);
    barCode.description = param.val;

    param = pFloat(param);
    var float = param.float;

    if (float[0] && float[0] == '1') {
        param = Common.pbit1(param);
        barCode.checkType = param.val;
    }

    if (float[1] && float[1] == '1') {
        param = Common.pbit4(param);
        barCode.constant1 = param.val;
    }

    if (float[2] && float[2] == '1') {
        param = Common.pbit4(param);
        barCode.constant2 = param.val;
    }
    return barCode;
};

Parse.Put = function (dId, data, encoding) {
    var param = {
        data: data,
        val: '',
        float: ''
    };

    var put = {};
    put.dId = dId;

    param = Common.pTxt(param, encoding);
    put.name = param.val;

    param = Common.pbit1(param);
    put.type = param.val;

    param = Common.pbit1(param);
    put.fontMode = param.val;

    param = Common.pbit1(param);
    put.high = param.val;

    param = Common.pbit1(param);
    put.width = param.val;

    param = Common.pbit1(param);
    put.sonCount = param.val;

    param = pFloat(param);
    var float = param.float;

    if (float[0] && float[0] == '1') {
        param = Common.pTxt(param, encoding);
        put.text1 = param.val;
    }

    if (float[1] && float[1] == '1') {
        param = Common.pTxt(param, encoding);
        put.text2 = param.val;
    }

    if (float[2] && float[2] == '1') {
        param = Common.pTxt(param, encoding);
        put.text3 = param.val;
    }

    if (float[3] && float[3] == '1') {
        param = Common.pTxt(param, encoding);
        put.text4 = param.val;
    }

    if (float[4] && float[4] == '1') {
        param = Common.pTxt(param, encoding);
        put.text5 = param.val;
    }

    if (float[5] && float[5] == '1') {
        param = Common.pTxt(param, encoding);
        put.text6 = param.val;
    }

    if (float[6] && float[6] == '1') {
        param = Common.pTxt(param, encoding);
        put.text7 = param.val;
    }

    if (float[16] && float[16] == '1') {
        param = Common.pTxt(param, encoding);
        put.text8 = param.val;
    }

    if (float[17] && float[17] == '1') {
        param = Common.pTxt(param, encoding);
        put.text9 = param.val;
    }

    if (float[18] && float[18] == '1') {
        param = Common.pTxt(param, encoding);
        put.text10 = param.val;
    }

    if (float[19] && float[19] == '1') {
        param = Common.pTxt(param, encoding);
        put.text11 = param.val;
    }
    if (float[20] && float[20] == '1') {
        param = Common.pTxt(param, encoding);
        put.text12 = param.val;
    }

    if (float[21] && float[21] == '1') {
        param = Common.pTxt(param, encoding);
        put.text13 = param.val;
    }

    if (float[22] && float[22] == '1') {
        param = Common.pTxt(param, encoding);
        put.text14 = param.val;
    }

    if (float[23] && float[23] == '1') {
        param = Common.pTxt(param, encoding);
        put.text15 = param.val;
    }

    if (float[24] && float[24] == '1') {
        param = Common.pTxt(param, encoding);
        put.text16 = param.val;
    }

    if (float[25] && float[25] == '1') {
        param = Common.pTxt(param, encoding);
        put.text17 = param.val;
    }

    if (float[26] && float[26] == '1') {
        param = Common.pTxt(param, encoding);
        put.text18 = param.val;
    }

    if (float[27] && float[27] == '1') {
        param = Common.pTxt(param, encoding);
        put.text19 = param.val;
    }

    if (float[28] && float[28] == '1') {
        param = Common.pTxt(param, encoding);
        put.text20 = param.val;
    }

    if (float[29] && float[29] == '1') {
        param = Common.pTxt(param, encoding);
        put.text21 = param.val;
    }

    if (float[30] && float[30] == '1') {
        param = Common.pTxt(param, encoding);
        put.text22 = param.val;
    }

    if (float[31] && float[31] == '1') {
        param = Common.pTxt(param, encoding);
        put.text23 = param.val;
    }

    if (float[32] && float[32] == '1') {
        param = Common.pTxt(param, encoding);
        put.text24 = param.val;
    }

    if (float[33] && float[33] == '1') {
        param = Common.pTxt(param, encoding);
        put.text25 = param.val;
    }

    if (float[34] && float[34] == '1') {
        param = Common.pTxt(param, encoding);
        put.text26 = param.val;
    }

    if (float[35] && float[35] == '1') {
        param = Common.pTxt(param, encoding);
        put.text27 = param.val;
    }

    if (float[36] && float[36] == '1') {
        param = Common.pTxt(param, encoding);
        put.text28 = param.val;
    }

    if (float[37] && float[37] == '1') {
        param = Common.pTxt(param, encoding);
        put.text29 = param.val;
    }

    if (float[38] && float[38] == '1') {
        param = Common.pTxt(param, encoding);
        put.text30 = param.val;
    }

    if (float[39] && float[39] == '1') {
        param = Common.pTxt(param, encoding);
        put.text31 = param.val;
    }

    var putSons = [];
    for (var i = 0; i < put.sonCount; i++) {
        var putSon = {};

        param = Common.pbit1(param);
        putSon.number = param.val;

        param = Common.pbit1(param);
        putSon.sgin0 = param.val;

        param = Common.pbit1(param);
        putSon.sgin1 = param.val;

        param = Common.pbit1(param);
        putSon.sgin2 = param.val;

        param = Common.pbit1(param);
        putSon.term = param.val;

        param = Common.pbit1(param);
        putSon.angle = param.val;

        param = Common.pbit1(param);
        putSon.align = param.val;

        param = Common.pbit1(param);
        putSon.fontNum = param.val;

        param = Common.pbit2(param);
        putSon.horizontal = param.val;

        param = Common.pbit2(param);
        putSon.vertical = param.val;

        param = Common.pbit2(param);
        putSon.width = param.val;

        param = Common.pbit2(param);
        putSon.high = param.val;
        putSon.push(putSon);
    }
    put.putSons = putSons;
    return put;
};

Parse.Assistant = function (dId, data, encoding) {
    var param = {
        data: data,
        val: '',
        float: ''
    };

    var assistant = {};
    assistant.dId = dId;

    param = Common.pTxt(param, encoding);
    assistant.name = param.val;

    param = pFloat(param);
    var float = param.float;

    if (float[0] && float[0] == '1') {
        param = Common.pbit4(param);
        assistant.pwd = param.val;
    }

    if (float[1] && float[1] == '1') {
        param = Common.pbit1(param);
        assistant.discountLower = param.val;
    }

    if (float[2] && float[2] == '1') {
        param = Common.pbit1(param);
        assistant.discountUpper = param.val;
    }

    if (float[4] && float[4] == '1') {
        param = Common.pbit4(param);
        assistant.security = param.val;
    }

    if (float[5] && float[5] == '1') {
        param = Common.pTxt(param, encoding);
        assistant.number = param.val;
    }
    return assistant;
};

Parse.Data = function (dId, data, encoding) {
    var dataData = {};
    dataData.dId = dId;
    dataData.value = parseInt(reverse(data), 16);
    return dataData;
};

Parse.Text = function (dId, data, encoding) {
    var param = {
        data: data,
        val: '',
    };

    var text = {};
    text.dId = dId;
    param = Common.pTxt(param, encoding);
    text.value = param.val;
    return text;
};

Parse.Keyboard = function (dId, data, encoding) {
    var keyboard = {};
    keyboard.dId = dId;
    keyboard.value = parseInt(reverse(data), 16);
    return keyboard;
};

Parse.Character_bank = function (dId, data, encoding) {
    var character_bank = {};
    character_bank.dId = dId;
    character_bank.data = data;
    return character_bank;
};

Parse.Bitmaps = function (dId, data, encoding) {
    var bitmaps = {};
    bitmaps.dId = dId;
    bitmaps.data = data;
    return bitmaps;
};

Parse.Update_file = function (dId, data, encoding) {
    var update_file = {};
    update_file.dId = dId;
    update_file.data = data;
    return update_file;
};

Parse.Remote_print = function (dId, data, encoding) {
    var remote_print = {};
    remote_print.dId = dId;
    remote_print.data = data;
    return remote_print;
};

/**
 * 汽车衡日志数据解析(暂未处理)
 * @param dId
 * @param data
 * @param encoding
 * @constructor
 */
Parse.Truck_Log = function (dId, data, encoding) {
    var truck_log = {};
    truck_log.dId = dId;
    truck_log.data = data;
    return truck_log;
};

/**
 * 汽车衡数据参数
 * @param dId
 * @param data
 * @param encoding
 * @constructor
 */
Parse.Truck_Data = function (dId, data, encoding) {
    var truck_data = {};
    truck_data.dId = dId;
    truck_data.data = parseInt(reverse(data),16);
    return truck_data;
};

/**
 * 解析浮动标志
 * @param param
 * @returns {*}
 */
var pFloat = function (param) {
        var float = [
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0',
            '0', '0', '0', '0', '0', '0', '0', '0'
        ];
        var data = param.data;

        if (!data || data.length < 2) {
            param.float = float;
            return param;
        }

        var part1 = reverseBin(parseInt(data.slice(0, 2), 16).toString(2));
        for (var i = 0; i < part1.length; i++) {
            float[i] = part1.charAt(i);
        }

        if (float['7'] == '0') {
            param.data = data.slice(2, data.length);
        } else {
            var part = reverseBin(parseInt(data.slice(2, 4), 16).toString(2));
            var count = 0;
            for (var i = 0; i < part.length; i++) {
                if (part.charAt(i) == '1') {
                    var temp = reverseBin(parseInt(data.slice(4 + count * 2, 6 + count * 2), 16).toString(2));
                    for (var j = 0; j < temp.length; j++) {
                        float[8 * (i + 2) + j] = temp.charAt(j);
                    }
                    count++;
                }
            }
            param.data = data.slice(4 + count * 2, data.length);
        }

        param.float = float;
        return param;
    },
    /**
     * 数据包内容解析
     * @param data
     * @param encoding
     * @param base64
     * @returns {Array}
     */
    parse = function (data, encoding, base64) {
        var param = {
            data: data,
            val: ''
        }
        // debugger

        if (base64) {
        } // todo data解压缩

        if (!encoding) encoding = "GBK";

        var arr = [];
        var state = "00";

        try {
            while (data) {
                param = Common.pbit1(param, true);

                var dMark = pushLength(param.val.toString(2), 8);
                var markCmd = dMark.slice(0, 2);
                var markSort = dMark.slice(2, 3);
                var markId = dMark.slice(3, 6);
                var markLen = dMark.slice(6, dMark.length);

                param = parseAppointLen(param, parseInt(markLen, 2) * 2);
                var dataLen = parseInt(param.val) * 2;

                param = appointLen(param, dataLen);
                var sort_id_data = param.val;

                data = param.data;

                var dataSortLen = (parseInt(markSort) + 1) * 2;
                var dSort, dId, dData;
                try {
                    dSort = reverse(sort_id_data.slice(0, dataSortLen).trim()).toUpperCase();
                } catch (e) {
                    state = DSORT;
                    break;
                }

                var dIdLen = parseInt(parseInt(markId, 2).toString(), 10) * 2;

                try {
                    dId = parseInt(fullHex(sort_id_data.slice(dataSortLen, dataSortLen + dIdLen)), 16);
                } catch (e) {
                    state = DDID;
                    break;
                }

                try {
                    dData = sort_id_data.slice(dataSortLen + dIdLen, sort_id_data.length);
                } catch (e) {
                    state = DDATA;
                    break;
                }

                var bean;

                switch (dSort) {
                    case '01':
                        bean = Parse.Log(dId, dData, encoding);
                        break;
                    case '02':
                        bean = Parse.Department(dId, dData, encoding);
                        break;
                    case '03':
                        bean = Parse.Group(dId, dData, encoding);
                        break;
                    case '04':
                        bean = Parse.PLU(dId, dData, encoding);
                        break;
                    case '05':
                        bean = Parse.BarCode(dId, dData, encoding);
                        break;
                    case '06':
                        bean = Parse.Put(dId, dData, encoding);
                        break;
                    case '07':
                        bean = Parse.Assistant(dId, dData, encoding);
                        break;
                    case '08':
                        bean = Parse.Data(dId, dData, encoding);
                        break;
                    case '09':
                        bean = Parse.Text(dId, dData, encoding);
                        break;
                    case '0A':
                        bean = Parse.Keyboard(dId, dData, encoding);
                        break;
                    case '0B':
                        bean = Parse.Character_bank(dId, dData, encoding);
                        break;
                    case '0C':
                        bean = Parse.Bitmaps(dId, dData, encoding);
                        break;
                    case '0D':
                        bean = Parse.Update_file(dId, dData, encoding);
                        break;
                    case '0E':
                        bean = Parse.Remote_print(dId, dData, encoding);
                        break;
                    case 'FF':
                        if (dId == '00') {
                            bean = Parse.checkDeviceHardware(dData, encoding);
                        } else if (dId == '01') {
                            bean = Parse.checkDeviceName(dData, encoding);
                        } else {
                            bean = Parse.checkDeviceTime(dData);
                        }
                        break;
                    case "0200":
                        bean = Parse.Truck_Log(dId, dData, encoding);
                        break;
                    case "0201":
                        bean = Parse.Truck_Data(dId, dData, encoding);
                        break;
                    default:
                        break;
                }
                bean.dCmd = markCmd;
                arr.push(bean);
            }
        } catch (e) {
            state = INPUT_EEROR;
        }
        return {
            state: state,
            arr: arr
        };
    },
    /**
     * 包Mark 解析
     * @param markStr
     * @returns {{mark: (string|*), encrypt: boolean, ask: boolean, remark: string, cd: string, lenBytes: *}}
     */
    parsePackageMark = function (markStr) {
        var mark = pushLength(parseInt(markStr, 16).toString(2), 8),
            encrypt = '1' == mark.charAt(0),// true 加密 false 不加密
            ack = '1' == mark.charAt(1), // true  应答 false 发送
            remark = mark.slice(2, 4),
            cd = mark.slice(4, 6),
            lenBytes = parseInt(reverse(mark.slice(6, 8)));
        return {
            'mark': mark,
            'encrypt': encrypt,
            'ack': ack,
            'remark': remark,
            'cd': cd,
            'lenBytes': lenBytes,
        };
    },
    /**
     * 整包解析
     * @param commond
     * @param aeskey
     * @returns {{nid: *, content: string}}
     */
    parsePackage = function (commond, aeskey) {
        if (!commond) return;
        commond = commond.replace(/(^02)|(03$)/g, '');
        var mark = parsePackageMark(commond.slice(0, 2));
        var markLength = parseInt(mark.lenBytes, 2);

        var nid, content, contentLength;
        if (mark && mark.lenBytes > 0) {
            nid = commond.slice(2, 6);

            contentLength = parseInt(reverse(commond.slice(6, 6 + markLength * 2)), 16);

            if (mark.encrypt) {
                // 加密协议并且密钥为空
                if (!aeskey) return;
                var aesContent = reverse(commond.slice(6 + markLength * 2, commond.length - 2));
                aesContent = aesContent;// todo aesDecrypt(aesContent, aeskey);
                console.log(JSON.stringify(aesContent));
                var fill = aesContent.slice(contentLength * 2, aesContent.length);
            } else {
                content = commond.slice(6 + markLength * 2, 6 + markLength * 2 + contentLength * 2);
            }
        }
        return {
            'mark': mark,
            'nid': nid,
            'content': content,
            'contentLength': contentLength
        };
    };

module.exports = {
  parse:parse,
  Parse:Parse
}



//////////////////
// WEBPACK FOOTER
// ./api/agreement/cr-agreement/parse.js
// module id = SRpU
// module chunks = 28